import React from 'react'

export const useMapMutableProps = <T, U>(
  prop: T,
  mapper: (v: T) => U
): [U, React.Dispatch<React.SetStateAction<U>>] => {
  const [mapped, setMapped] = React.useState<U>(() => mapper(prop))

  React.useEffect(() => {
    setMapped(mapper(prop))
  }, [prop, mapper])

  return [mapped, setMapped]
}
